import { createSlice } from '@reduxjs/toolkit';

import { dispatch } from '../index';

// initial state
const initialState = {
    openItem: [],
    drawerOpen: false
};

// ==============================|| SLICE - MENU ||============================== //

const menu = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        activeItem(state, action) {
            state.openItem = action.payload;
        },

        openDrawer(state, action) {
            state.drawerOpen = action.payload;
        },
        resetState(state) {
            state.openItem = initialState.openItem;
        }
    }
});

export function resetSelectedMenuItem() {
    return dispatch(menu.actions.resetState());
}

export default menu.reducer;

export const { activeItem, openDrawer } = menu.actions;
